import React from "react";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";

const PlantOverview = ({
    type = "purchase",
    projectEnable = false,
    solarPlantSize,
    avgUnitGeneration,
    paybackPeriod,
    monthlyLease,
    lifetimeSavings,
    icons,
}) => {
    return (
        <div className="bg-gray-100 hidden shadow-md p-3 mt-2 rounded-3xl md:flex justify-between items-center">
            <div className="flex gap-1.5 items-center">
                <img src={icons.solar} />
                <div className="flex flex-col gap-0.5">
                    <P className="md:text-sm xl:text-sm">Solar Plant Size</P>
                    <H4 className="sm:text-xxl">
                        {projectEnable ? solarPlantSize : "XXX"}
                    </H4>
                </div>
            </div>

            {type === "purchase" ? (
                <>
                    <div className="flex gap-1 items-center">
                        <img src={icons.carbon} />
                        <div className="flex flex-col gap-0.5">
                            <P className="md:text-sm xl:text-sm">
                                Avg Unit Generation
                            </P>
                            <H4 className="sm:text-xxl">
                                {projectEnable ? avgUnitGeneration : "XXX"}
                            </H4>
                        </div>
                    </div>
                    <div className="flex gap-1 items-center">
                        <img src={icons.streamLine} />
                        <div className="flex flex-col gap-0.5">
                            <P className="md:text-sm xl:text-sm">
                                Payback Period
                            </P>
                            <H4 className="sm:text-xxl">
                                {projectEnable ? paybackPeriod : "XXX"}
                            </H4>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="flex gap-1 items-center">
                        <img src={icons.carbon} />
                        <div className="flex flex-col gap-0.5">
                            <P className="md:text-sm xl:text-sm">
                                Monthly Lease Payment
                            </P>
                            <H4 className="sm:text-xxl">
                                {projectEnable ? monthlyLease : "XXX"}
                            </H4>
                        </div>
                    </div>
                    <div className="flex gap-1 items-center">
                        <img src={icons.streamLine} />
                        <div className="flex flex-col gap-0.5">
                            <P className="md:text-sm xl:text-sm">
                                Lifetime Savings
                            </P>
                            <H4 className="sm:text-xxl">
                                {projectEnable ? lifetimeSavings : "XXX"}
                            </H4>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default PlantOverview;
